module.exports = require("@mui/material/MenuItem");